import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/analytics'
import 'firebase/compat/storage'
import 'firebase/compat/messaging'
import 'firebase/compat/functions'
import 'firebase/compat/database'

const firebaseConfig = {
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_DATABASE_URL,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_APP_ID,
    // measurementId: process.env.REACT_APP_GAID
}

// Inicializa solo una vez (por si se re-importa en hot reload)
const firebaseInit = !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.app()

/**
 * La sesión de Firebase vive en `sessionStorage` (una por PESTAÑA) y no en IndexedDB (una por ORIGEN,
 * que es el default `LOCAL`). Sin esto hay un solo `currentUser` para todo el navegador: el ingreso
 * desde el BO pisa el del login propio, y el logout de cualquiera de los dos se lleva puesta la sesión
 * del otro. Ver `docs/TOKEN_SESSION_ISOLATION.md`.
 *
 * `setPersistence` es asíncrono y migra la sesión que ya estuviera guardada al nuevo medio (borra la
 * entrada vieja, así que no deja refresh tokens huérfanos). Quien lea el estado de auth al montar debe
 * esperar esta promesa: leer antes significa leer contra la persistencia vieja.
 */
export const authReady = firebase
    .auth()
    .setPersistence(firebase.auth.Auth.Persistence.SESSION)
    .catch((error) => {
        // Best-effort: si falla, la app sigue con la persistencia por defecto en vez de quedar sin auth.
        // eslint-disable-next-line no-console
        console.warn('[Auth] No se pudo fijar la persistencia por pestaña:', error)
    })

export default firebaseInit
export { firebase }
